import { Link } from "react-router-dom";

export default function Footer1() {
    return (
        <>
        <footer className="footer-1">
            <div className="footer-1-top">
                <div className="auto-container">
                    <div className="footer-1-top-content d-flex align-items-center justify-content-between">
                        <div className="logo"><Link href="/"><img src="assets/images/newnewLogo.png" alt="" /></Link></div>
                        <ul className="footer-1-social-icon d-flex align-items-center">
                            <li><Link href="/"><i className="fab fa-facebook-f"></i></Link></li>
                            <li><Link href="/"><i className="fab fa-twitter"></i></Link></li>
                            <li><Link href="/"><i className="fab fa-linkedin-in"></i></Link></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="footer-1-middle">
                <div className="auto-container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="about-widget-1">
                                <div className="footer-widget-title"><h4>About</h4></div>
                                <div className="about-widget-1-text">
                                    <p>We acknowledge the traditional owners of the lands on which we live and <br />
                                    work. we pay our respects to elders past, present and emerging. we are <br /> committed to honouring indigenous peoples’ unique cultural and spiritual <br /> relationships to the land, waters and seas and their rich contribution to society. We support community and their equality.</p>
                                    
                                    
                                    <img src="assets/images/shape/flags.jpeg" alt="flags" width={150} />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="link-widget-1 px-lg-5">
                                <div className="footer-widget-title"><h4></h4></div>
                                
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="link-widget-1">
                                <div className="footer-widget-title"><h4>Quick Link</h4></div>
                                <ul className="link-widget-1-list">
                                    <li><a href="https://newranss.com.au/#about">About Us</a></li>
                                    <li><Link href="https://services.newranss.com.au/">Services</Link></li>
                                    <li><a href="https://newranss.com.au/#contact">Contact Us</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="contact-widget-1">
                                <div className="footer-widget-title"><h4>Contact Us</h4></div>
                                <div className="contact-widget-text">Newran SS</div>
                                <ul className="contact-widget-1-list">
                                    <li><i className="icon-14"></i> Suite 30-D2, 2232B, Albany Highway, Gosnells WA 6110</li>
                                    <li><i className="icon-14"></i> 5 Birch Street, Maddington WA 6109</li>
                                    <li><i className="icon-3"></i><Link href="mailto:example@newran.com">admin@newranss.com.au</Link></li>
                                    <li><i className="icon-2"></i><Link href="tel:0422 411 652">0422 411 652</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="auto-container">    
                    <div className="footer-bottom-row">
                        <div className="footer-bottom-text">Copyright 2025 by MyLkSystems. All Right Reserved.</div>
                    </div>
                </div>
            </div>
        </footer>

        </>
    )
}
